import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index";
import router from "@/router";

import loginModel from "@/models/authentication/login";
import { oAuthMethod } from "@/configs/provider/oauth-method";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import { initialAbility } from "@/libs/acl/config";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import th from "date-fns/esm/locale/th/index";

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

import { countryData } from "@/configs/countries";

export default function useLoginAction() {
  const vm = getCurrentInstance().proxy;

  const { getMenuListMBK } = usePermissionByAccount()

  const {
    fetchGetAvailableLogin,
    fetchLoginOAuth,
    fetchLogin,
    fetchBrandList,
    fetchSubmitBrand,
    GetUserChangePasswordFirstTime,
    fetchResetPassword,
    fetchRequestOTP,
    fetchResendRequestOTP,
  } = loginModel();

  const {
    openErrorModal,
    openDefaultErrorModal,
    openSuccessModal,
  } = useValidationModal();

  const loginForm = reactive({
    status: "",
    password: "",
    userEmail: "",
    sideImg: "",
    passwordFieldType: "password",
    rememberMe: [],
    brandRef: "",
    provider_ref: "",
    brandRefSelect: "",

    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    currentPasswordFieldType: "password",
    newPasswordFieldType: "password",
    confirmPasswordFieldType: "password",
    mobileNo: "",
    mobileNoWithCode: "",
    mobileOTP: "",
    mobileCountry: {
      countryData: {
        alpha2: "TH",
        th: "ไทย",
        en: "Thailand",
        phoneCode: "66",
      },
      alpha2: "TH",
      label: "Thailand",
      value: "+66",
    },
  });

  const requestOTPData = reactive({
    data: null,
    errorData: null,
    isResndOTP: false,
  });

  const selectBrandForm = reactive({
    accessToken: "",
    refreshToken: "",
    state: "",
    payload: "",
    brandRef: "",
  });

  const oAuthDisplay = reactive({
    providerList: [],
    line: null,
    google: null,
    facebook: null,
  });

  const loading = reactive({
    loadingAvailableLogin: false,
    signIn: false,
    brandList: false,
    changePassword: false,
  });

  const brandList = ref([]);

  const stepIndexActive = ref(0);

  const stepActive = reactive({
    LOGIN: 0,
    SELECT_BRAND: 1,
    CHANGE_PASSWORD: 2,
    FORGET_PASSWORD: 3,
    VERIFY_OTP: 4,
  });

  const passwordToggle = {
    CURRENT_PASSWORD: 1,
    NEW_PASSWORD: 2,
    CONFIRM_NEW_PASSWORD: 3,
  };

  const optionData = reactive({
    telephoneCountry: [],
  });

  const togglePasswordVisibility = (password) => {
    switch (password) {
      case passwordToggle.CURRENT_PASSWORD:
        loginForm.currentPasswordFieldType =
          loginForm.currentPasswordFieldType === "password"
            ? "text"
            : "password";
        break;
      case passwordToggle.NEW_PASSWORD:
        loginForm.newPasswordFieldType =
          loginForm.newPasswordFieldType === "password" ? "text" : "password";
        break;
      case passwordToggle.CONFIRM_NEW_PASSWORD:
        loginForm.confirmPasswordFieldType =
          loginForm.confirmPasswordFieldType === "password"
            ? "text"
            : "password";
        break;
      default:
        loginForm.passwordFieldType =
          loginForm.passwordFieldType === "password" ? "text" : "password";
    }
  };

  const handlerLoginSuccess = (resp, fromSelectBrand = false) => {
    return new Promise(async(resolve, reject) => {
      loginForm.brandRef = resp.brand_ref;
      let bcrmBrands = [];
      if (localStorage.getItem(window.brandLocalStorage)) {
        bcrmBrands = [
          ...JSON.parse(localStorage.getItem(window.brandLocalStorage))?.filter(
            (o) => {
              return o.brandRef != loginForm.brandRef;
            }
          ),
        ];
      }
      bcrmBrands.push({
        brandRef: loginForm.brandRef,
        accessToken: resp.access_token,
        refreshToken: resp.refresh_token,
        payload: resp.payload,
        providerRef: loginForm.provider_ref?.value,
      });
      localStorage.setItem(
        window.brandLocalStorage,
        JSON.stringify(bcrmBrands)
      );
      
      // get navigation list brand mbk BOYNYKJMS2EH
      await getMenuListMBK()

      vm.$ability.update([{ action: "manage", subject: "all" }]);

      resolve();
    });
  };

  const login = () => {
    return new Promise((resolve, reject) => {
      if (loginForm.provider_ref.oAuthMethod == oAuthMethod.mobileOtp) {
        window.$loading(true);
        fetchLogin.payload.brand_ref = loginForm.brandRef;
        fetchLogin.payload.provider_ref = loginForm.provider_ref?.value;
        fetchLogin.payload.username = loginForm.mobileNoWithCode;
        fetchLogin.payload.password = loginForm.password;
      } else {
        if (!loginForm.userEmail || !loginForm.password) return;
        loading.signIn = true;
        fetchLogin.payload.brand_ref = loginForm.brandRef;
        fetchLogin.payload.provider_ref = loginForm.provider_ref?.value;
        fetchLogin.payload.username = loginForm.userEmail;
        fetchLogin.payload.password = loginForm.password;
      }

      store
        .dispatch("api/apiRequest", fetchLogin)
        .then((response) => {
          const resp = response.data;

          localStorage.setItem("account", JSON.stringify(atob(resp.payload)));

          if (loginForm.provider_ref.oAuthMethod == oAuthMethod.mobileOtp) {
            if (response.status == "success") {
              if (resp.action == "Home") {
                handlerLoginSuccess(resp).then(() => {
                  window.location.href =
                    "/landing?brandRef=" + loginForm.brandRef;
                });
              }
            }
          } else {
            getChangePasswordFirstTime().then((isChangePassword) => {
              if (isChangePassword == false) {
                stepIndexActive.value = stepActive.CHANGE_PASSWORD;

                router
                  .replace({
                    name: "auth-login",
                    query: {
                      access_token: resp.access_token,
                      refresh_token: resp.refresh_token,
                      payload: resp.payload,
                    },
                  })
                  .catch(() => {});
              } else {
                if (response.status == "success") {
                  if (resp.action == "Home") {
                    handlerLoginSuccess(resp).then(() => {
                      window.location.href =
                        "/landing?brandRef=" + loginForm.brandRef;
                    });
                  } else {
                    stepIndexActive.value = stepActive.SELECT_BRAND;
                    router
                      .replace({
                        name: "select-brand",
                        query: {
                          access_token: resp.access_token,
                          refresh_token: resp.refresh_token,
                          payload: resp.payload,
                        },
                      })
                      .catch(() => {});
                    getBrandList(
                      resp.access_token,
                      resp.refresh_token,
                      "",
                      resp.payload
                    );
                  }
                }
              }
            });
          }
          resolve(resp);
        })
        .catch((error) => {
          if (loginForm.provider_ref.oAuthMethod == oAuthMethod.mobileOtp) {
            return reject(error);
          }

          const errResp = error.data.error;

          if (errResp.code == 1106007) {
            const title = errResp.locale["th-th"].title;
            const detailError = errResp.locale["th-th"].message;
            const detail = detailError
              .split("xx")
              .join(parseInt(errResp.message));
            openErrorModal(title, detail);
          } // account lock
          else {
            openDefaultErrorModal(error, "th");
          }
        })
        .finally(() => {
          loading.signIn = false;
          window.$loading(false);
        });
    });
  };

  const submitBrand = ({
    accessToken = null,
    refreshToken = null,
    brandRef = null,
    payload = null,
    state = null,
  }) => {
    return new Promise((resolve, reject) => {
      loading.signIn = true;
      fetchSubmitBrand.payload.access_token =
        accessToken || selectBrandForm.accessToken;
      fetchSubmitBrand.payload.refresh_token =
        refreshToken || selectBrandForm.refreshToken;
      fetchSubmitBrand.payload.brand_ref =
        brandRef || loginForm.brandRefSelect?.value;
      fetchSubmitBrand.payload.payload = payload || selectBrandForm.payload;
      fetchSubmitBrand.payload.state = state || selectBrandForm.state || "";
      store
        .dispatch("api/apiRequest", fetchSubmitBrand)
        .then((response) => {
          const resp = response.data;
          sessionStorage.setItem(
            window.brandSessionStorage,
            response.data.brand_ref
          );
          resolve(resp);
          handlerLoginSuccess(resp, true).then(() => {
            window.location.href = "/landing?brandRef=" + loginForm.brandRef;
          });
        })
        .catch((error) => {
          reject(error);
          openErrorModal("เกิดข้อผิดพลาด", "ไม่สามารถเลือก Brand ได้ในขณะนี้");
        })
        .finally(() => {
          loading.signIn = false;
        });
    });
  };

  const passwordToggleIcon = computed(() => {
    return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
  });

  const imageUrl = computed(() => {
    return this.sideImg;
  });

  const resolveShowSocialMedia = computed(() => {
    return oAuthDisplay.google || oAuthDisplay.facebook || oAuthDisplay.line;
  });

  const getAvailableLoginMethod = () => {
    loginForm.brandRef = router.currentRoute.query.brandRef;
    loading.loadingAvailableLogin = true;
    fetchGetAvailableLogin.payload.brand_ref =
      router.currentRoute.query.brandRef;
    store
      .dispatch("api/apiRequest", fetchGetAvailableLogin)
      .then((response) => {
        oAuthDisplay.google =
          response.data.find((o) => {
            return o.oauth_method == oAuthMethod.googleAccount;
          })?.provider_ref || null;
        oAuthDisplay.facebook =
          response.data.find((o) => {
            return o.oauth_method == oAuthMethod.facebook;
          })?.provider_ref || null;
        oAuthDisplay.line =
          response.data.find((o) => {
            return o.oauth_method == oAuthMethod.line;
          })?.provider_ref || null;
        let providerTemp = response.data.filter((o) => {
          return (
            o.oauth_method != oAuthMethod.googleAccount &&
            o.oauth_method != oAuthMethod.facebook &&
            o.oauth_method != oAuthMethod.line
          );
        });
        if (providerTemp.length == 1) {
          loginForm.provider_ref = {
            label: providerTemp[0].provider_name,
            value: providerTemp[0].provider_ref,
            oAuthMethod: providerTemp[0].oauth_method,
          };
        } else if (providerTemp.length > 1) {
          oAuthDisplay.providerList = providerTemp.map((providerObj) => ({
            label: providerObj.provider_name,
            value: providerObj.provider_ref,
            oAuthMethod: providerObj.oauth_method,
          }));
        }
      })
      .finally(() => {
        loading.loadingAvailableLogin = false;
      });
  };

  const getBrandList = (
    accessToken,
    refreshToken,
    state = "",
    payload = ""
  ) => {
    selectBrandForm.accessToken = accessToken;
    selectBrandForm.refreshToken = refreshToken;
    selectBrandForm.state = state;
    selectBrandForm.payload = payload;
    selectBrandForm.brandRef = router.currentRoute.query.brandRef;
    fetchBrandList.payload.access_token = accessToken;
    store
      .dispatch("api/apiRequest", fetchBrandList)
      .then((response) => {
        brandList.value = [];
        response.data.map((o) => {
          brandList.value.push({
            label: o.brand_name,
            value: o.brand_ref,
          });
        });
        // flow change brand
        store.dispatch("brand/setBrandList", brandList.value);
        store.dispatch("brand/setBrandInfo", selectBrandForm);
      })
      .finally(() => {});
  };

  const loginWithOAuth = (method) => {
    const oAuthSelected = {
      google: oAuthDisplay.google,
      facebook: oAuthDisplay.facebook,
      line: oAuthDisplay.line,
    }[method];
    fetchLoginOAuth.payload.brand_ref = loginForm.brandRef || "";
    fetchLoginOAuth.payload.provider_ref = oAuthSelected;
    window.location.href = `${fetchLoginOAuth.api}?brand_ref=${fetchLoginOAuth.payload.brand_ref}&provider_ref=${fetchLoginOAuth.payload.provider_ref}&redirect_uri=${process.env.VUE_APP_ENDPOINT_FRONT}`;
  };

  const checkLoginAuth = async () => {
    try {
      let searchParams = new URLSearchParams(window.location.search);
      let brandRef = searchParams.get("brandRef");
      let brands = JSON.parse(localStorage.getItem(window.brandLocalStorage));
      let brandObj = brands?.find((o) => {
        return o.brandRef == brandRef;
      });
      if (brandObj?.brandRef) {
        //  flow new tab
        fetchBrandInfo().then((value) => {
          getBrandListInfo(value);
        });
      }
    } catch {}
  };

  const getChangePasswordFirstTime = () => {
    return new Promise((resolve, reject) => {
      GetUserChangePasswordFirstTime.payload.Username = loginForm.userEmail;
      GetUserChangePasswordFirstTime.payload.Provider_Ref =
        loginForm.provider_ref?.value;

      store
        .dispatch("api/apiRequest", GetUserChangePasswordFirstTime)
        .then((response) => {
          resolve(response.data.is_change);
        })
        .catch((error) => {
          reject(error);
          openDefaultErrorModal(error);
        })
        .finally(() => {});
    });
  };

  const resetPassword = ({
    accessToken = null,
    providerRef = null,
    userName = null,
    newPassword = null,
    oldPassword = null,
  }) => {
    loading.changePassword = true;
    window.$loading(true);
    return new Promise((resolve, reject) => {
      fetchResetPassword.payload.Access_Token = accessToken;
      fetchResetPassword.payload.Provider_Ref = providerRef;
      fetchResetPassword.payload.Username = userName;
      fetchResetPassword.payload.New_Password = newPassword;
      fetchResetPassword.payload.Old_Password = oldPassword;

      store
        .dispatch("api/apiRequest", fetchResetPassword)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.changePassword = false;
          window.$loading(false);
        });
    });
  };

  const onChangePassword = (passwordForm) => {
    if (!passwordForm) return;

    resetPassword({
      accessToken: router.currentRoute.query.access_token,
      providerRef: loginForm.provider_ref?.value,
      userName: loginForm.userEmail,
      newPassword: passwordForm.newPassword,
      oldPassword: passwordForm.currentPassword,
    })
      .then((value) => {
        onSuccessModal().then((value) => {
          forceLogout();
        });
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      });
  };

  const forceLogout = () => {
    loginForm.userEmail = "";
    loginForm.provider_ref = "";
    loginForm.password = "";
    loginForm.currentPassword = "";
    loginForm.newPassword = "";
    loginForm.confirmNewPassword = "";
    stepIndexActive.value = stepActive.LOGIN;
    let brands = JSON.parse(
      localStorage.getItem(window.brandLocalStorage)
    ).filter((o) => {
      return o.brandRef != sessionStorage.getItem(window.brandSessionStorage);
    });

    localStorage.setItem(window.brandLocalStorage, JSON.stringify(brands));
    // Reset ability
    vm.$ability.update(initialAbility);
    vm.$router.push({ name: "auth-login" });
  };

  const checkPasswordError = (message) => {
    const showTextError = document.getElementById("show-text-error");
    showTextError.className = "show";
    let div = showTextError.querySelector("div");
    div.innerText = message;
  };

  const onSuccessModal = () => {
    return new Promise((resolve, reject) => {
      openSuccessModal(
        "ทำรายการสำเร็จ !",
        null,
        null,
        () => {
          resolve();
        },
        () => {
          resolve();
        }
      );
    });
  };

  const onCheckPassFormat = (password) => {
    const pass = password.replace(
      /[^a-zA-Z0-9-_~`!@#$%^&*()_+=[\]\{}|;':",./]/g,
      ""
    );
    return pass;
  };

  const getBrandListInfo = (brandObj) => {
    // flow change brand
    return new Promise((resolve) => {
      getBrandList(
        brandObj.accessToken,
        brandObj.refreshToken,
        "",
        brandObj.payload
      );
      resolve(brandList);
    });
  };

  const fetchBrandInfo = () => {
    return new Promise((resolve) => {
      const findExistingToken = JSON.parse(
        localStorage.getItem(window.brandLocalStorage)
      )?.filter((o) => {
        return (
          o.brandRef ==
          (new URLSearchParams(window.location.search).get("brand_ref") ||
            sessionStorage.getItem(window.brandSessionStorage))
        );
      });
      const existingToken = findExistingToken?.length > 0;

      if (existingToken) {
        vm.$ability.update([{ action: "manage", subject: "all" }]);
        resolve(findExistingToken[0]);
      }
    });
  };

  const onGetTelephoneCountryData = () => {
    if (!countryData) return;

    return new Promise((resolve, reject) => {
      let telephoneCountry = { ...countryData.phone };
      let countryNameList = [...countryData.nameList];
      let countryDataOption = [];

      countryNameList.map((country) => {
        let obj = {};
        obj.alpha2 = country.alpha2.toUpperCase();
        obj.th = country.th;
        obj.en = country.en;
        obj.phoneCode = telephoneCountry[country.alpha2];

        countryDataOption.push(obj);
      });

      resolve(countryDataOption);
    });
  };

  const onSetTelephoneCountryData = (telephoneCountryList) => {
    if (!telephoneCountryList) return;
    telephoneCountryList.map((country) => {
      let phCode =
        country.phoneCode.includes("+") == false
          ? `+${country.phoneCode}`
          : country.phoneCode;
      optionData.telephoneCountry.push({
        countryData: { ...country },
        alpha2: country.alpha2,
        label: country.en,
        value: phCode,
      });
    });
  };

  const onRequestMOTP = () => {
    loading.signIn = true;
    fetchRequestOTP.payload.brand_ref = loginForm.brandRef;
    fetchRequestOTP.payload.provider_Ref = loginForm.provider_ref?.value;
    fetchRequestOTP.payload.mobile_no = "" + parseInt(loginForm.mobileNo);
    fetchRequestOTP.payload.country_code =
      loginForm.mobileCountry.countryData.phoneCode;
    fetchRequestOTP.payload.verify_user = true;

    store
      .dispatch("api/apiRequest", fetchRequestOTP)
      .then((response) => {
        requestOTPData.data = {
          ...response.data,
          brandRef: loginForm.brandRef,
          providerRef: loginForm.provider_ref?.value,
          mobileNo: parseInt(loginForm.mobileNo),
          mobileCountry: loginForm.mobileCountry,
        };

        stepIndexActive.value = stepActive.VERIFY_OTP;
      })
      .catch((err) => {
        console.log(err);
        openDefaultErrorModal(err);
      })
      .finally(() => {
        loading.signIn = false;
      });
  };

  const onResendRequestOTP = (payload) => {
    window.$loading(true);

    requestOTPData.isResndOTP = true;

    fetchResendRequestOTP.payload.brand_ref = payload.brandRef;
    fetchResendRequestOTP.payload.provider_ref = payload.providerRef;
    fetchResendRequestOTP.payload.mobile_no = payload.mobileNo;
    fetchResendRequestOTP.payload.country_code = payload.mobileCountryCode;
    fetchResendRequestOTP.payload.tx_reference = payload.txRef;
    fetchResendRequestOTP.payload.verify_user = true;

    store
      .dispatch("api/apiRequest", fetchResendRequestOTP)
      .then((response) => {
        requestOTPData.data = {
          ...response.data,
          brandRef: loginForm.brandRef,
          providerRef: loginForm.provider_ref?.value,
          mobileNo: parseInt(loginForm.mobileNo),
          mobileCountry: loginForm.mobileCountry,
        };
        requestOTPData.errorData = null;
        stepIndexActive.value = stepActive.VERIFY_OTP;
      })
      .catch((err) => {
        console.log(err);
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onLoginWithVerifyOTP = (payload) => {
    requestOTPData.isResndOTP = false;

    loginForm.brandRef = payload.brandRef;
    loginForm.mobileNoWithCode = payload.userName;
    loginForm.password = payload.password;

    login()
      .then((result) => {
        requestOTPData.errorData = null;
      })
      .catch((error) => {
        const errResp = error.data.error;
        requestOTPData.errorData = { ...errResp };
      });
  };

  const onInputNumber = (e) => {
    const num = e.replace(/\D/g, "");
    return num;
  };

  onBeforeMount(async () => {
    if (
      ["error", "fail"].indexOf(
        new URLSearchParams(window.location.search).get("status")
      ) != -1
    ) {
      setTimeout(() => {
        openErrorModal("เกิดข้อผิดพลาด", "คุณไม่มีสิทธิ์ในการ Login");
        router.replace("/").catch(() => {});
      }, 300);
    }
    if (router.currentRoute.name == "select-brand") {
      stepIndexActive.value = stepActive.SELECT_BRAND;
      getBrandList(
        router.currentRoute.query.access_token,
        router.currentRoute.query.refresh_token,
        router.currentRoute.query.state,
        router.currentRoute.query.payload
      );
    } else {
      await checkLoginAuth();
      getAvailableLoginMethod();
      onGetTelephoneCountryData().then((value) => {
        onSetTelephoneCountryData(value);
      });
    }
  });

  const onForgetPassword = () => {
    stepIndexActive.value = stepActive.FORGET_PASSWORD;
    loginForm.brandRef = router.currentRoute.query.brandRef;
  };

  return {
    loginForm,
    passwordToggleIcon,
    imageUrl,
    oAuthDisplay,
    resolveShowSocialMedia,
    loading,
    brandList,
    togglePasswordVisibility,
    login,
    loginWithOAuth,
    submitBrand,
    getBrandList,
    selectBrandForm,
    onChangePassword,
    passwordToggle,
    checkPasswordError,
    resetPassword,
    onSuccessModal,
    onCheckPassFormat,
    oAuthMethod,
    optionData,
    onRequestMOTP,
    onLoginWithVerifyOTP,
    requestOTPData,
    onResendRequestOTP,
    onInputNumber,
    onForgetPassword,
    stepIndexActive,
    stepActive,
    fetchBrandInfo,
    getBrandListInfo,
  };
}
